import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
interface ServicePageHeroProps {
  title: string;
  subtitle: string;
}
export function ServicePageHero({
  title,
  subtitle
}: ServicePageHeroProps) {
  return <div className="bg-brand-navy py-20 relative overflow-hidden" data-id="element-159">
      {/* Subtle Grid Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
      backgroundSize: '50px 50px'
    }} data-id="element-160"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-162">
          {/* Breadcrumb */}
          <div className="flex items-center text-sm text-gray-400 mb-6 font-medium" data-id="element-163">
            <Link to="/" className="hover:text-brand-amber transition-colors" data-id="element-164">
              Home
            </Link>
            <ChevronRight className="w-4 h-4 mx-2" data-id="element-165" />
            <Link to="/services" className="hover:text-brand-amber transition-colors" data-id="element-166">
              Services
            </Link>
            <ChevronRight className="w-4 h-4 mx-2" data-id="element-167" />
            <span className="text-white" data-id="element-168">{title}</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-extrabold text-white mb-6" data-id="element-169">
            {title}
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl leading-relaxed" data-id="element-170">
            {subtitle}
          </p>
        </motion.div>
      </div>
    </div>;
}